import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ICurrentPromotionalEventResponse) {
    (function(IPromotionalEvent) {
        (function(IStyle) {
            IStyle.build = function(partial) {
                return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPromotionalEvent.IStyle || (IPromotionalEvent.IStyle = {}));
        (function(IMobileImages) {
            IMobileImages.build = function(partial) {
                return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPromotionalEvent.IMobileImages || (IPromotionalEvent.IMobileImages = {}));
        (function(PromotionalEventGroup) {
            PromotionalEventGroup["PROMOTIONAL_EVENT_GROUP_UNKNOWN"] = "PROMOTIONAL_EVENT_GROUP_UNKNOWN";
            PromotionalEventGroup["MARKET"] = "MARKET";
            PromotionalEventGroup["FASHION_WEEK"] = "FASHION_WEEK";
        })(IPromotionalEvent.PromotionalEventGroup || (IPromotionalEvent.PromotionalEventGroup = {}));
        (function(IImages) {
            IImages.build = function(partial) {
                return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPromotionalEvent.IImages || (IPromotionalEvent.IImages = {}));
        IPromotionalEvent.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ICurrentPromotionalEventResponse.IPromotionalEvent || (ICurrentPromotionalEventResponse.IPromotionalEvent = {}));
    ICurrentPromotionalEventResponse.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICurrentPromotionalEventResponse || (ICurrentPromotionalEventResponse = {}));
export var ICurrentPromotionalEventResponse;
